let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3rtfT")).then(() => parcelRequire('c5LJI'));